module.exports = __webpack_public_path__ + "assets/smile.2e974f6d.svg";